import React, { useState, useEffect } from 'react'
import { retrieveDateobj } from '../../config/commonfunctions'
import { Checkdevice } from '../Checkdevice'
import './Invdate.css'

const from_params_map = {
    'Details': {
        'WEB': { mainwt: '100%', mainminwt: 115, mainfs: 24, subfs: 20, slashmargin: 10, scale: 1 },
        'TABLET': { mainwt: '100%', mainminwt: 115, mainfs: 22, subfs: 18, slashmargin: 10, scale: 1 },
        'MOBILE': { mainwt: '85%', mainminwt: 115, mainfs: 19, subfs: 15, slashmargin: 10, scale: 1 },
    },
    'Invitationlookup_1': {
        'WEB': { mainwt: '100%', mainminwt: 115, mainfs: 25, subfs: 20, slashmargin: 10, scale: 1 },
        'TABLET': { mainwt: '100%', mainminwt: 115, mainfs: 25, subfs: 20, slashmargin: 10, scale: 1 },
        'MOBILE': { mainwt: '100%', mainminwt: 115, mainfs: 25, subfs: 20, slashmargin: 10, scale: 0.98 },
    },
    'Invitationlookup_2': {
        'WEB': { mainwt: '100%', mainminwt: 115, mainfs: 30, subfs: 25, slashmargin: 10, scale: 1 },
        'TABLET': { mainwt: '100%', mainminwt: 115, mainfs: 30, subfs: 25, slashmargin: 10, scale: 1 },
        'MOBILE': { mainwt: '100%', mainminwt: 115, mainfs: 25, subfs: 20, slashmargin: 10, scale: 0.98 },
    },
    'T1sim': {
        'WEB': { mainwt: '60%', mainminwt: 73, mainfs: 13, subfs: 9, slashmargin: 3, scale: 1 },
        'TABLET': { mainwt: '60%', mainminwt: 73, mainfs: 13, subfs: 9, slashmargin: 3, scale: 1 },
        'MOBILE': { mainwt: '60%', mainminwt: 73, mainfs: 13, subfs: 9, slashmargin: 3, scale: 1 },
    },
    'T1simmobile': {
        'WEB': { mainwt: '100%', mainminwt: 72, mainfs: 13, subfs: 9, slashmargin: 3, scale: 1 },
        'TABLET': { mainwt: '100%', mainminwt: 72, mainfs: 13, subfs: 9, slashmargin: 3, scale: 1 },
        'MOBILE': { mainwt: '100%', mainminwt: 72, mainfs: 13, subfs: 9, slashmargin: 3, scale: 1 },
    },
    'T2sim': {
        'WEB': { mainwt: '60%', mainminwt: 73, mainfs: 15, subfs: 13, slashmargin: 3, scale: 1 },
        'TABLET': { mainwt: '60%', mainminwt: 73, mainfs: 15, subfs: 13, slashmargin: 3, scale: 1 },
        'MOBILE': { mainwt: '60%', mainminwt: 73, mainfs: 15, subfs: 13, slashmargin: 3, scale: 1 },
    },
    'T2simmobile': {
        'WEB': { mainwt: '100%', mainminwt: 72, mainfs: 14, subfs: 10, slashmargin: 3, scale: 1.2 },
        'TABLET': { mainwt: '100%', mainminwt: 72, mainfs: 14, subfs: 10, slashmargin: 3, scale: 1.2 },
        'MOBILE': { mainwt: '100%', mainminwt: 72, mainfs: 14, subfs: 10, slashmargin: 3, scale: 1.2 },
    }
}


const CountdownTimer = ({ targetDateISO, from }) => {
    const params = {
        'Details': { margin: '15px 0px', fontSize: '2rem' },
        'Invitationlookup_1': { margin: '40px 0px 20px 0px', fontSize: '2.5rem' },
        'Invitationlookup_2': { margin: '40px 0px 20px 0px', fontSize: '2.5rem' },
        'T1sim': { margin: '15px 0px', fontSize: '1.5rem' },
        'T2sim': { margin: '15px 0px', fontSize: '1.5rem' },
        'T1simmobile': { margin: '15px 0px', fontSize: '1.25rem' },
        'T2simmobile': { margin: '15px 0px', fontSize: '1.25rem' },
    }

    const targetDate = targetDateISO ? new Date(targetDateISO) : null;
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        if (!targetDate || isNaN(targetDate)) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diff = targetDate - now;

            if (diff <= 0) {
                clearInterval(timer);
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            } else {
                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((diff / (1000 * 60)) % 60);
                const seconds = Math.floor((diff / 1000) % 60);

                setTimeLeft({ days, hours, minutes, seconds });
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <div style={{ ...params[from] }}>
            {`${timeLeft.days}d : ${String(timeLeft.hours).padStart(2, '0')}h : ${String(timeLeft.minutes).padStart(2, '0')}m : ${String(timeLeft.seconds).padStart(2, '0')}s`}
        </div>
    );
};


function normal(countdown, rawdate, mainwt, fc, props, from, mainfs, dateobj, time) {
    const params = {
        'Details': '15px 0px',
        'Invitationlookup_1': '20px 0px',
        'Invitationlookup_2': '20px 0px',
        'T1sim': '15px 0px',
        'T2sim': '15px 0px',
        'T1simmobile': '15px 0px',
        'T2simmobile': '15px 0px',

    }
    return <div key={from + 'normal' + Math.random()} style={{ width: mainwt, color: fc, fontFamily: props.datetimeff, margin: params[from], display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', }}>
        <div style={{ display: 'flex', flexDirection: 'column', padding: params[from] }}>
            <div style={{ fontSize: mainfs }}>{dateobj.date}</div>
            <div style={{ fontSize: mainfs }}>{time}</div>
        </div>

        {(rawdate && countdown) ? <CountdownTimer targetDateISO={rawdate} from={from} /> : null}
    </div>
}

function common(countdown, rawdate, a, b, c, d, time, fc, mainwt, mainfs, subfs, mainminwt, ff, from, scale,) { // placement of datetime_dom
    // const from_params_map = {
    //     'Details': {
    //         'WEB': { },
    //         'TABLET': {},
    //         'MOBILE': {},
    //     },
    //     'Invitationlookup_1': {
    //         'WEB': {margin:'20px 0px'},
    //         'TABLET': {margin:'20px 0px'},
    //         'MOBILE': {margin:'20px 0px'},
    //     },
    //     'T1sim': {
    //         'WEB': {},
    //         'TABLET': {},
    //         'MOBILE': {},
    //     },
    //     'T1simmobile': {
    //         'WEB': {},
    //         'TABLET': {},
    //         'MOBILE': {},
    //     }
    // }

    const params = {
        'Details': '15px 0px',
        'Invitationlookup_1': '20px 0px',
        'Invitationlookup_2': '20px 0px',
        'T1sim': '15px 0px',
        'T2sim': '15px 0px',
        'T1simmobile': '15px 0px',
        'T2simmobile': '15px 0px',

    }

    const justborder = from === 'Details' ? `0.5px solid var( --maindark )` : `1px solid ${fc}4d`

    return (
        <div key={from + 'normal' + Math.random()} style={{ width: mainwt, color: fc, fontFamily: ff, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', transform: `scale(${scale})` }}>

            <div style={{ display: 'flex', flexDirection: 'row', padding: params[from], letterSpacing: 1 }}>

                <div style={{ fontSize: subfs, padding: '0px 10px', alignItems: 'center', display: 'flex', justifyContent: 'center', minWidth: mainminwt }}>
                    {a}
                </div>

                <div style={{ borderLeft: justborder, borderRight: justborder, padding: '0px 10px', display: 'flex', flexDirection: 'column', minWidth: mainminwt }}>
                    <div style={{ fontSize: subfs }} >{b}</div>
                    <div style={{ fontSize: mainfs, }}>{c}</div>
                    <div style={{ fontSize: subfs }}>{d}</div>
                </div>
                <div style={{ fontSize: subfs, padding: '0px 10px', alignItems: 'center', display: 'flex', justifyContent: 'center', minWidth: mainminwt }}>{time}</div>

            </div>

            {(rawdate && countdown) ? <CountdownTimer targetDateISO={rawdate} from={from} /> : null}

        </div>
    )
}

function stacktopdown(countdown, rawdate, from, day, date, time, fc, mainwt, mainfs, subfs, slashmargin, ff) {
    const params = {
        'Details': '15px 0px',
        'Invitationlookup_1': '20px 0px',
        'Invitationlookup_2': '20px 0px',
        'T1sim': '15px 0px',
        'T2sim': '15px 0px',
        'T1simmobile': '15px 0px',
        'T2simmobile': '15px 0px',
    }

    const justborder = from === 'Details' ? `0.5px solid var( --maindark )` : `1px solid ${fc}4d`

    return (
        <div key={from + 'stacktopdown' + Math.random()} style={{ width: mainwt, color: fc, fontFamily: ff, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', }}>

            <div style={{ display: 'flex', flexDirection: 'row', padding: params[from] }}>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0px 10px' }}>
                    <div style={{ fontSize: subfs }}>{day}</div>
                    <div style={{ fontSize: subfs }}>{date.split("/").join('.')}</div>
                </div>

                <div style={{ borderLeft: justborder, display: 'flex', flexDirection: 'column', transform: 'rotate(22.5deg)', margin: slashmargin }} />

                <div style={{ fontSize: mainfs, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0px 10px' }}>
                    <div>{time}</div>
                </div>

            </div>

            {(rawdate && countdown) ? <CountdownTimer targetDateISO={rawdate} from={from} /> : null}

        </div>
    )
}

function Invdate(props) {
    const { date_e, date_w, itype, dt_type, time, fc, from, datetimeff, countdown } = props
    const [dateobj, setDateobj] = useState({}) // {date:'', day:'', d:'', m:'', y:''}
    const [rawdate, setRawdate] = useState(null)
    const device = Checkdevice()
    const { mainwt, mainfs, subfs, slashmargin, mainminwt, scale } = from_params_map[from][device]
    useEffect(() => {
        let obj_date_str =
            (itype === 'Wedding' && date_w && date_w.toString().length > 0)
                ? date_w
                : (itype === 'Event' && date_e && date_e.toString().length > 0)
                    ? date_e
                    : '';
        setRawdate(obj_date_str);
        setDateobj(retrieveDateobj(obj_date_str));
    }, [itype, date_w, date_e]);

    return dateobj && Object.keys(dateobj).length === 5
        ? {
            'Wedding': {
                0: normal(countdown, rawdate, mainwt, fc, props, from, mainfs, dateobj, time),
                1: common(countdown, rawdate, dateobj.day, dateobj.m, dateobj.d, dateobj.y, time, fc, mainwt, mainfs, subfs, mainminwt, datetimeff, from, scale,),
                2: common(countdown, rawdate, dateobj.m, dateobj.day, dateobj.d, dateobj.y, time, fc, mainwt, mainfs, subfs, mainminwt, datetimeff, from, scale,),
                3: stacktopdown(countdown, rawdate, from, dateobj.day, dateobj.date, time, fc, mainwt, mainfs, subfs, slashmargin, datetimeff,)
            },
            'Event': {}
        }[itype][parseInt(dt_type, 10)]
        : <div key={'invdatehidden' + Math.random()} style={{ width: 0, height: 0, visibility: 'hidden' }} />
}

export default Invdate
